let topSectionDiscountBanner = $('#topSectionBanner');

function bannerHeight() {
    let bannerHeight = Math.floor(topSectionDiscountBanner.outerHeight());

    document.documentElement.style.setProperty('--bannerHeight', bannerHeight + 'px');

    // console.log('bannerHeight: ' + bannerHeight)
}

function scrollbarWidth() {
    document.documentElement.style.setProperty('--scrollbarWidth', (window.innerWidth - document.documentElement.clientWidth) + 'px');
}

if (topSectionDiscountBanner.length) {
    bannerHeight();
    scrollbarWidth();
}

$(window).resize(bannerHeight);